import { CatharsisArgs } from '@wix/thunderbolt-catharsis'

export const getInvalidationHandler = (set: Set<string>): CatharsisArgs['onInvalidation'] => (path, get) => {
	const [, aspect] = path

	if (aspect !== 'widgets') {
		return
	}

	const widegts = get<Array<string>>(path)
	if (widegts) {
		widegts.forEach((widget) => set.add(widget))
	}
}
